/* eslint-disable max-len */
import React from 'react';
import { Switch, Route, withRouter, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import TransactionsContainer from './transactions/TransactionsContainer';

function ReportsContainer({ match }) {
  return (
    <Switch>
      <Route
        exact
        path={`${match.path}`}
        render={() => <Redirect to={`${match.path}/transactions`} />}
      />
      <Route
        path={`${match.path}/transactions`}
        component={TransactionsContainer}
      />
    </Switch>
  );
}

ReportsContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

export default withRouter(ReportsContainer);
